import { useCallback } from 'react';
import styled from '@emotion/styled';
import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import LocalePreferenceModal from 'src/components/LocalePreference';
import useCallbackWithCheckLogin from 'src/hooks/useCallbackWithCheckLogin';
import { matchFilterSelectionsAtom } from 'src/stores/match/atoms';
import { showModalAtom, closeModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
import FilterButton from './FilterButton';
const Title = styled.div`
  color: ${({
  theme
}) => theme.color.content10};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
`;
const TextWrap = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const Description = styled.div`
  color: ${({
  theme
}) => theme.color.content9};
  font-size: 12px;
  font-weight: 400;
`;
const Wrap = styled.div`
  padding: 12px 0;
  gap: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const RegionFilterRow = () => {
  const {
    t
  } = useTranslation();
  const showModal = useSetAtom(showModalAtom);
  const closeModal = useSetAtom(closeModalAtom);
  const matchFilterSelections = useAtomValue(matchFilterSelectionsAtom);
  const handleDismiss = useCallback(() => {
    closeModal(ModalType.MATCH_SETTING_INNER);
  }, [closeModal]);
  const handleSelect = useCallbackWithCheckLogin(() => {
    showModal({
      key: ModalType.MATCH_SETTING_INNER,
      component: () => <LocalePreferenceModal onDismiss={handleDismiss} />
    });
  });
  const filterSelection = matchFilterSelections.find(({
    filterId
  }) => filterId === 'STATE_CHOICE');
  return <Wrap data-sentry-element="Wrap" data-sentry-component="RegionFilterRow" data-sentry-source-file="RegionFilter.tsx">
      <TextWrap data-sentry-element="TextWrap" data-sentry-source-file="RegionFilter.tsx">
        <Title data-sentry-element="Title" data-sentry-source-file="RegionFilter.tsx">{t('vividi_genderfilter_sheet_subtitle_region')}</Title>
        <Description data-sentry-element="Description" data-sentry-source-file="RegionFilter.tsx">{t('vividi_genderfilter_sheet_subdesc_region')}</Description>
      </TextWrap>
      <FilterButton target='regionfilter' onClick={handleSelect} data-sentry-element="FilterButton" data-sentry-source-file="RegionFilter.tsx">
        {t('vividi_genderfilter_region_selected', {
        count: filterSelection?.multiSelectOptionKeys?.length ?? 0
      })}
      </FilterButton>
    </Wrap>;
};
export default RegionFilterRow;